import RouteView from '@/layouts/RouteView'

export default {
  path: '/id-info-mana/index',
  name: 'IdInfo.Search',
  // redirect: '/shop-mana/index',
  meta: { icon: 'user', title: '人员查询', bread: true },
  component: () =>
    import(/* webpackChunkName: 'clientMana' */ '@/views/id-info-mana/search/index.vue'),
}
